import { render, staticRenderFns } from "./dependentUpdate.vue?vue&type=template&id=8517bff2&scoped=true&"
import script from "./dependentUpdate.vue?vue&type=script&lang=js&"
export * from "./dependentUpdate.vue?vue&type=script&lang=js&"
import style0 from "./dependentUpdate.vue?vue&type=style&index=0&id=8517bff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8517bff2",
  null
  
)

export default component.exports